import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
export const getOrderById = async (orderId: string) => {
  const url = `${ENDPOINTS.ORDERS}/${orderId}`
  const { data } = await api.get<OrderByIdResponseType>(url)
  return data
}
const useOrderById = (orderId: string) => {
  return useQuery({
    queryKey: [ENDPOINTS.ORDERS, orderId],
    queryFn: () => getOrderById(orderId),
  })
}
export default useOrderById
